module.exports = __webpack_public_path__ + "static/img/22.0e13596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22.jpg
// module id = H2aL
// module chunks = 0